// HighTide Account Modal JavaScript

document.addEventListener("DOMContentLoaded", function () {
  initAccountModal();
});

function initAccountModal() {
  const modal = document.getElementById("account-modal");
  if (!modal) return;

  const closeBtn = document.getElementById("close-account-modal");
  const overlay = modal.querySelector(".ht-account-modal__overlay");
  const accountIcon = document.getElementById("account-icon-trigger");

  // Check if customer is logged in (passed from Liquid)
  const loginFormContainer = document.getElementById("login-form-container");
  const loggedInView = document.getElementById("logged-in-view");
  const modalTitle = document.getElementById("modal-title");

  // Show correct view based on login state
  if (window.shopifyCustomer) {
    if (loginFormContainer) loginFormContainer.style.display = "none";
    if (loggedInView) loggedInView.style.display = "block";
    if (modalTitle) modalTitle.textContent = "My Account";
  }

  // Close modal function
  function closeModal() {
    modal.classList.remove("active");
  }

  // Open modal function
  function openModal() {
    modal.classList.add("active");
  }

  // Close button click
  if (closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }

  // Overlay click
  if (overlay) {
    overlay.addEventListener("click", closeModal);
  }

  // Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("active")) {
      closeModal();
    }
  });

  // Account icon click
  if (accountIcon) {
    accountIcon.addEventListener("click", function (e) {
      e.preventDefault();
      openModal();
    });
  }

  // Make openAccountModal available globally
  window.openAccountModal = openModal;

  // Auto-open if there are form errors
  if (window.accountModalHasErrors) {
    openModal();
  }

  console.log("Account modal initialized");
}
